/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.5.0 (NJsonSchema v10.6.6.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class HealthClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getHealth(): Promise<HealthStatus> {
        let url_ = this.baseUrl + "/Health";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetHealth(_response);
        });
    }

    protected processGetHealth(response: Response): Promise<HealthStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HealthStatus.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<HealthStatus>(<any>null);
    }
}

export class IapAccessClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    recordIapAccess(accessEntry: IapAccessEntry): Promise<FileResponse> {
        let url_ = this.baseUrl + "/IapAccess";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accessEntry);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processRecordIapAccess(_response);
        });
    }

    protected processRecordIapAccess(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(<any>null);
    }
}

export class HealthStatus implements IHealthStatus {
    buildEnvironment?: string | undefined;
    requestDateUtc?: Date;

    constructor(data?: IHealthStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildEnvironment = _data["buildEnvironment"];
            this.requestDateUtc = _data["requestDateUtc"] ? new Date(_data["requestDateUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HealthStatus {
        data = typeof data === 'object' ? data : {};
        let result = new HealthStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildEnvironment"] = this.buildEnvironment;
        data["requestDateUtc"] = this.requestDateUtc ? this.requestDateUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IHealthStatus {
    buildEnvironment?: string | undefined;
    requestDateUtc?: Date;
}

export class IapAccessEntry implements IIapAccessEntry {
    accessTarget!: IapAccessTarget;

    constructor(data?: IIapAccessEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accessTarget = _data["accessTarget"];
        }
    }

    static fromJS(data: any): IapAccessEntry {
        data = typeof data === 'object' ? data : {};
        let result = new IapAccessEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accessTarget"] = this.accessTarget;
        return data;
    }
}

export interface IIapAccessEntry {
    accessTarget: IapAccessTarget;
}

export enum IapAccessTarget {
    Home = 0,
    Admin = 1,
    Compliance = 2,
    Licensing = 3,
    Marketing = 4,
    Operations = 5,
    Sales = 6,
    Dtc = 7,
    Setup = 8,
    DataDictionary = 9,
    Emp = 10,
}

export class ApiRequestLog implements IApiRequestLog {
    userEmail?: string | undefined;
    service!: string;
    host?: string | undefined;
    requestTime!: Date;
    requestMethod!: string;
    endpoint!: string;
    remoteAddress!: string;
    referer?: string | undefined;
    traceId?: string | undefined;

    constructor(data?: IApiRequestLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userEmail = _data["userEmail"];
            this.service = _data["service"];
            this.host = _data["host"];
            this.requestTime = _data["requestTime"] ? new Date(_data["requestTime"].toString()) : <any>undefined;
            this.requestMethod = _data["requestMethod"];
            this.endpoint = _data["endpoint"];
            this.remoteAddress = _data["remoteAddress"];
            this.referer = _data["referer"];
            this.traceId = _data["traceId"];
        }
    }

    static fromJS(data: any): ApiRequestLog {
        data = typeof data === 'object' ? data : {};
        let result = new ApiRequestLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userEmail"] = this.userEmail;
        data["service"] = this.service;
        data["host"] = this.host;
        data["requestTime"] = this.requestTime ? this.requestTime.toISOString() : <any>undefined;
        data["requestMethod"] = this.requestMethod;
        data["endpoint"] = this.endpoint;
        data["remoteAddress"] = this.remoteAddress;
        data["referer"] = this.referer;
        data["traceId"] = this.traceId;
        return data;
    }
}

export interface IApiRequestLog {
    userEmail?: string | undefined;
    service: string;
    host?: string | undefined;
    requestTime: Date;
    requestMethod: string;
    endpoint: string;
    remoteAddress: string;
    referer?: string | undefined;
    traceId?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}